<template>
  <section class="problems-item">
    <div class="container">
      <div class="headline-container">
        <div class="number">{{ number }}</div>
        <h6>{{ headline }}</h6>
      </div>
      <p v-for="paragraph in paragraphs" :key="paragraph" v-html="paragraph" />
    </div>
  </section>
</template>

<script>
export default {
  props: {
    number: Number,
    headline: String,
    paragraphs: Array,
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/fonts';
@import '~@/assets/styles/colors';
@import '~@/assets/styles/variables';
@import '~@/assets/styles/breakpoints';

.problems-item {
  width: 50%;
}

.container {
  margin: 20px 26px;
}

.headline-container {
  display: flex;
}

.number {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 34px;
  width: 34px;
  border-radius: $border-radius;
  background-color: $background-red;
  color: $red;
  font-size: $font-size-headline-small;
  font-weight: bold;
}

h6 {
  max-width: 260px;
  margin: 0 0 8px 12px;
}

p {
  margin: 0 0 20px 46px;
}

p:last-of-type {
  margin-bottom: 0;
}

@media (max-width: $page-table-breakpoint) {
  .problems-item {
    width: 100%;
    max-width: $page-mobile-large-breakpoint;
  }
}

@media (max-width: $page-mobile-large-breakpoint) {
  .headline-container {
    flex-direction: column;
  }

  .container {
    margin: 20px 15px;
  }

  h6 {
    padding: 10px 0;
  }

  h6,
  p {
    margin: 0;
  }
}
</style>
